let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("67JWT")).then(() => parcelRequire('dO6p9'));